import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wc-hero" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "wc-hero-inner" }
const _hoisted_4 = { class: "wc-hero-actions" }
const _hoisted_5 = { class: "wc-section" }
const _hoisted_6 = { class: "container mw-1356" }
const _hoisted_7 = { class: "wc-features-grid" }
const _hoisted_8 = { class: "wc-section wc-dark" }
const _hoisted_9 = { class: "container mw-1356" }
const _hoisted_10 = { class: "wc-schedule-grid" }
const _hoisted_11 = { class: "wc-phase-badge" }
const _hoisted_12 = { class: "wc-section" }
const _hoisted_13 = { class: "container mw-1356" }
const _hoisted_14 = { class: "wc-channels-grid" }
const _hoisted_15 = { class: "wc-section wc-dark" }
const _hoisted_16 = { class: "container mw-1356" }
const _hoisted_17 = { class: "text-center mt-5" }
const _hoisted_18 = { class: "wc-section" }
const _hoisted_19 = {
  class: "container mw-1356",
  style: {"max-width":"800px"}
}
const _hoisted_20 = { class: "wc-faq-list" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "wc-faq-q" }
const _hoisted_23 = {
  key: 0,
  class: "wc-faq-a"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarTwo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wc-badge" }, "FIFA World Cup 2026", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h1", null, [
            _createTextVNode("Watch Every World Cup 2026 Match "),
            _createElementVNode("span", { class: "wc-red" }, "Live in HD")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "All 104 matches. 48 teams. 3 countries. Stream every kick-off live on any device with goplayTv — from the Group Stage to the Final.", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: "/pricing",
              class: "btn wc-btn-primary"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "border-style" }, "Get Started — From $10/mo", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/channels",
              class: "btn"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "border-style" }, "Browse Channels", -1)
              ])),
              _: 1
            })
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"wc-stats-row\" data-v-3a5ad514><div class=\"wc-stat\" data-v-3a5ad514><span data-v-3a5ad514>104</span><p data-v-3a5ad514>Matches</p></div><div class=\"wc-stat\" data-v-3a5ad514><span data-v-3a5ad514>48</span><p data-v-3a5ad514>Teams</p></div><div class=\"wc-stat\" data-v-3a5ad514><span data-v-3a5ad514>25,000+</span><p data-v-3a5ad514>Channels</p></div><div class=\"wc-stat\" data-v-3a5ad514><span data-v-3a5ad514>4K</span><p data-v-3a5ad514>Quality</p></div></div>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "wc-section-title" }, "Why Watch World Cup 2026 on goplayTv?", -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (f) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "wc-feature-card",
              key: f.title
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(f.icon)
              }, null, 2),
              _createElementVNode("h3", null, _toDisplayString(f.title), 1),
              _createElementVNode("p", null, _toDisplayString(f.desc), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "wc-section-title" }, "Tournament Overview", -1)),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phases, (phase) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "wc-schedule-card",
              key: phase.name
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(phase.dates), 1),
              _createElementVNode("h4", null, _toDisplayString(phase.name), 1),
              _createElementVNode("p", null, _toDisplayString(phase.desc), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "wc-section-title" }, "Channels Broadcasting World Cup 2026", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "wc-section-sub" }, "goplayTv carries every major broadcaster so you never miss a match regardless of your location.", -1)),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (ch) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "wc-channel-tag",
              key: ch
            }, _toDisplayString(ch), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[11] || (_cache[11] = _createStaticVNode("<h2 class=\"wc-section-title\" data-v-3a5ad514>How to Watch in 3 Steps</h2><div class=\"wc-steps-row\" data-v-3a5ad514><div class=\"wc-step\" data-v-3a5ad514><div class=\"wc-step-num\" data-v-3a5ad514>1</div><h4 data-v-3a5ad514>Choose a Plan</h4><p data-v-3a5ad514>Pick any subscription from $10/month. Instant activation.</p></div><div class=\"wc-step-arrow\" data-v-3a5ad514><i class=\"ti ti-arrow-right\" data-v-3a5ad514></i></div><div class=\"wc-step\" data-v-3a5ad514><div class=\"wc-step-num\" data-v-3a5ad514>2</div><h4 data-v-3a5ad514>Get Your Line</h4><p data-v-3a5ad514>Receive your M3U/credentials via email within minutes.</p></div><div class=\"wc-step-arrow\" data-v-3a5ad514><i class=\"ti ti-arrow-right\" data-v-3a5ad514></i></div><div class=\"wc-step\" data-v-3a5ad514><div class=\"wc-step-num\" data-v-3a5ad514>3</div><h4 data-v-3a5ad514>Watch Live</h4><p data-v-3a5ad514>Load on Smart TV, phone, tablet, Firestick, or PC and enjoy.</p></div></div>", 2)),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_RouterLink, {
            to: "/pricing",
            class: "btn wc-btn-primary"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("span", { class: "border-style" }, "Subscribe Now →", -1)
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "wc-section-title" }, "World Cup 2026 FAQ", -1)),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (q, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "wc-faq-item",
              key: i,
              onClick: ($event: any) => (_ctx.openFaq = _ctx.openFaq === i ? -1 : i)
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(q.q), 1),
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.openFaq === i ? 'ti ti-chevron-up' : 'ti ti-chevron-down')
                }, null, 2)
              ]),
              (_ctx.openFaq === i)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(q.a), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_21))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_MainFooter, { class: "bg-black" }),
    _createVNode(_component_CopyRight)
  ], 64))
}